(() => {
  const enquiry = new URLSearchParams(window.location.search).get('enquiry');
  if (enquiry !== 'affiliate-existing' && enquiry !== 'affiliate-new') return;

  document.querySelectorAll('.editorial-contact-form').forEach((form) => {
    if (form.querySelector('.editorial-contact-form__notice')) return;
    const subject = form.querySelector('select[name="contact[Subject]"]');
    if (!subject || subject.selectedIndex !== 0) return;
    const option = Array.from(subject.options).find((item) => item.dataset.affiliateEnquiry === enquiry);
    if (!option) return;
    subject.value = option.value;
  });
})();
